"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.coeffIntervalPage = coeffIntervalPage;
function coeffIntervalPage() {
    return [
        ["A min", "0.07"],
        ["A max", "0.13"],
        ["A step", "0.01"],
        ["B min", "-0.32"],
        ["B max", "-0.2"],
        ["B step", "0.01"],
        ["C min", "1.1"],
        ["C max", "1.8"],
        ["C step", "0.05"],
        ["D min", "1.4"],
        ["D max", "1.9"],
        ["D step", "0.05"]
    ];
}
//# sourceMappingURL=coeff-interval-page.js.map